import { ActionTree, GetterTree, MutationTree } from "vuex";
import { CustomerStoreType } from "@/types/CustomerTypes";

const state: CustomerStoreType = {
  customerId: "",
  msisdn: "",
  deliveryAddress: {
    zipCode: "",
    street: "",
    number: "",
    complement: "",
    district: "",
    city: "",
    uf: "",
  },
  customer: {
    name: "",
    document: "",
    birthdate: "",
    email: "",
    contactPhone: 0,
    phonePortability: 0,
    password: "",
    purchaseOrderId: "",
  },
  useAddress: true,
  customerAddress: {
    zipCode: "",
    street: "",
    number: "",
    complement: "",
    district: "",
    city: "",
    uf: "",
  },
  eligibilityAddress: false,
  planSelected: undefined,
  discountsSelected: "",
  couponSelected: "",
  webview: "false",
  deadline: 48,
  deliveryType: "CONVENCIONAL",
};

const getters: GetterTree<CustomerStoreType, any> = {
  customerId: (st) => st.customerId,
  msisdn: (st) => st.msisdn,
  customer: (st) => st.customer,
  customerDocument: (st) => st.customer.document,
  deliveryAddress: (st) => st.deliveryAddress,
  useAddress: (st) => st.useAddress,
  customerAddress: (st) => st.customerAddress,
  eligibilityAddress: (st) => st.eligibilityAddress,
  planSelected: (st) => st.planSelected,
  discountsSelected: (st) => st.discountsSelected,
  couponSelected: (st) => st.couponSelected,
  webview: (st) => st.webview,
  deadline: (st) => st.deadline,
  deliveryType: (st) => st.deliveryType,
};

const mutations: MutationTree<CustomerStoreType> = {
  setCustomerId(st: CustomerStoreType, customerId) {
    st.customerId = customerId;
  },
  setCustomerDocument(st: CustomerStoreType, customerDocument) {
    st.customer.document = customerDocument;
  },
  setMsisdn(st: CustomerStoreType, msisdn) {
    st.msisdn = msisdn;
  },
  setDeliveryAddress(st: CustomerStoreType, deliveryAddress) {
    st.deliveryAddress = deliveryAddress;
  },
  setCustomer(st: CustomerStoreType, customer) {
    st.customer = customer;
  },
  setUseAddress(st: CustomerStoreType, useAddress) {
    st.useAddress = useAddress;
  },
  setCustomerAddress(st: CustomerStoreType, customerAddress) {
    st.customerAddress = customerAddress;
  },
  setCustomerPassword(st: CustomerStoreType, password) {
    st.customer.password = password;
  },
  setPurchaseOrderId(st: CustomerStoreType, purchaseOrderId) {
    st.customer.purchaseOrderId = purchaseOrderId;
  },
  setEligibilityAddress(st: CustomerStoreType, eligibilityAddress) {
    st.eligibilityAddress = eligibilityAddress;
  },
  setPlanSelected(st: CustomerStoreType, planSelected) {
    st.planSelected = planSelected;
  },
  setDiscountsSelected(st: CustomerStoreType, discountsSelected) {
    st.discountsSelected = discountsSelected;
  },
  setCouponSelected(st: CustomerStoreType, couponSelected) {
    st.couponSelected = couponSelected;
  },
  setWebview(st: CustomerStoreType, webview) {
    st.webview = webview;
  },
  setDeadline(st: CustomerStoreType, deadline) {
    st.deadline = deadline;
  },
  setDeliveryType(st: CustomerStoreType, type) {
    st.deliveryType = type;
  },
  setContactPhone(st: CustomerStoreType, number) {
    st.customer.contactPhone = number;
  },
  setPhonePortability(st: CustomerStoreType, phone) {
    st.customer.phonePortability = phone;
  },
  setReset(st: CustomerStoreType) {
    st.customerId = "";
    st.msisdn = "";
    st.deliveryAddress = {
      zipCode: "",
      street: "",
      number: "",
      complement: "",
      district: "",
      city: "",
      uf: "",
    };
    st.customer = {
      name: "",
      document: "",
      birthdate: "",
      email: "",
      contactPhone: 0,
      phonePortability: 0,
      password: "",
      purchaseOrderId: "",
    };
    st.useAddress = true;
    st.customerAddress = {
      zipCode: "",
      street: "",
      number: "",
      complement: "",
      district: "",
      city: "",
      uf: "",
    };
    st.useAddress = true;
    st.eligibilityAddress = false;
    st.planSelected = undefined;
    st.webview = "true";
    st.deadline = 48;
    st.deliveryType = "CONVENCIONAL";
  },
};

const actions: ActionTree<CustomerStoreType, any> = {
  async setCustomerId({ commit }, customerId) {
    localStorage.setItem("x-customer-id", customerId);
    commit("setCustomerId", customerId);
  },
  async setCustomerDocument({ commit }, customerDocument) {
    commit("setCustomerDocument", customerDocument);
  },
  setMsisdn({ commit }, msisdn) {
    commit("setMsisdn", msisdn);
  },
  setDeliveryAddress({ commit }, deliveryAddress) {
    commit("setDeliveryAddress", deliveryAddress);
  },
  setCustomer({ commit }, customer) {
    commit("setCustomer", customer);
  },
  setUseAddress({ commit }, useAddress) {
    commit("setUseAddress", useAddress);
  },
  setCustomerAddress({ commit }, customerAddress) {
    commit("setCustomerAddress", customerAddress);
  },
  setCustomerPassword({ commit }, password) {
    commit("setCustomerPassword", password);
  },
  setPurchaseOrderId({ commit }, purchaseOrderId) {
    commit("setPurchaseOrderId", purchaseOrderId);
  },
  setEligibilityAddress({ commit }, eligibilityAddress) {
    commit("setEligibilityAddress", eligibilityAddress);
  },
  setPlanSelected({ commit }, planSelected) {
    commit("setPlanSelected", planSelected);
  },
  setDiscountsSelected({ commit }, discountsSelected) {
    commit("setDiscountsSelected", discountsSelected);
  },
  setCouponSelected({ commit }, couponSelected) {
    commit("setCouponSelected", couponSelected);
  },
  setWebview({ commit }, webview) {
    commit("setWebview", webview);
  },
  setDeadline({ commit }, deadline) {
    commit("setDeadline", deadline);
  },
  setDeliveryType({ commit }, type) {
    commit("setDeliveryType", type);
  },
  setContactPhone({ commit }, number) {
    commit("setContactPhone", number);
  },
  setPhonePortability({ commit }, phone) {
    commit("setPhonePortability", phone);
  },
  setResetCustomer({ commit }) {
    commit("setReset");
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
